import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CalenderUpIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.104 16.9446C3.104 16.7098 3.18227 16.4751 3.37794 16.3185L12.379 7.47507C12.7312 7.12289 13.2791 7.12289 13.6313 7.47507L22.6323 16.3185C22.9845 16.6707 22.9845 17.2185 22.6323 17.5707C22.2801 17.9229 21.7322 17.9229 21.38 17.5707L13.0051 9.35333L4.63026 17.6099C4.27805 17.962 3.73016 17.962 3.37794 17.6099C3.2214 17.3751 3.104 17.1794 3.104 16.9446Z"
      fill="#004E9B"
    />
  </svg>
);
export default CalenderUpIcon;
